import { Injectable } from '@angular/core';
import { BaseApiService } from '@ep/shared';
import { catchError, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EmailService extends BaseApiService {
  private readonly emailEndpoint = '/v2/Emails';
  private readonly linxEventEndpoint = '/v2/LinxEvents/send-missing-theme-email';

  sendEmail(message: string): Observable<any> {
    return this.post(this.linxEventEndpoint, { message }).pipe(
      catchError((err) => {
        console.error('Error sending email:', err);
        return of(null);
      })
    );
  }

  findUnique(email: string) {
    return this.get(`${this.emailEndpoint}/check`, {
      email: email,
    }).pipe(
      catchError((err) => {
        console.error(err);
        return of(null);
      })
    );
  }
}
